import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import EmployeesList from './EmployeesList';

function Employees() {
  return (
    <Routes>
      <Route path="/" element={<EmployeesList />} />
      <Route path="*" element={<Navigate to="/dashboard/employees" replace />} />
    </Routes>
  );
}

export default Employees;
